import React, { useState, useEffect } from "react";
import {
  Alert,
  IconButton,
  InputAdornment,
  TextField,
  FormControl,
  InputLabel,
  OutlinedInput,
  Grid,
  Button,
  Box,
} from "@mui/material";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import axiosClient from "../axiosClient";

const CustomerProfileScreen = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState();
  const [email, setEmail] = useState();

  useEffect(() => {
    axiosClient
      .get("customer/authenticated")
      .then((response) => {
        console.log(response);
        setEmail(response.data.customer_email);
      })
      .catch((err) => console.log(err));
  }, []);

  const changePassword = () => {
    const payload = {
      params: {
        email: email,
        password: password,
      },
    };
    axiosClient
      .patch("customer/password", payload)
      .then((response) => {
        setMessage(response.data.message);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      })
      .catch((err) => console.log(err));
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  return (
    <div>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={4}>
          {message && (
            <Alert severity="success" sx={{ marginBottom: 1 }}>
              {message}
            </Alert>
          )}
        </Grid>
      </Grid>
      <Box m={3} />
      <Grid container xs={12} md={3} sm={3} lg={3}>
        <TextField
          label="Email"
          value={email}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          type="text"
          fullWidth
          disabled={true}
        />
      </Grid>
      <Box m={3} />
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={4} sm={4} lg={4}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel htmlFor={`outlined-adornment-password`}>
              Password
            </InputLabel>
            <OutlinedInput
              id={`outlined-adornment-password`}
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={handlePasswordChange}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleTogglePasswordVisibility}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Password"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={3} sm={3} lg={3}>
          <Button variant="contained" color="success" onClick={changePassword}>
            Change password
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default CustomerProfileScreen;
